var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup715(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 136,
    viewBox: "0 0 209 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 11.5,
    width: 190,
    height: 114,
    rx: 6,
    fill: "#E7F4E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.9998 52.645C55.5845 52.645 57.6798 50.5497 57.6798 47.965C57.6798 45.3803 55.5845 43.285 52.9998 43.285C50.4151 43.285 48.3198 45.3803 48.3198 47.965C48.3198 50.5497 50.4151 52.645 52.9998 52.645Z",
    stroke: "#292D32",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4301 45.235C43.3851 32.245 62.6301 32.26 65.5701 45.25C67.2951 52.87 62.5551 59.32 58.4001 63.31C55.3851 66.22 50.6151 66.22 47.5851 63.31C43.4451 59.32 38.7051 52.855 40.4301 45.235Z",
    stroke: "#292D32",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.5 0.5H204.5C206.709 0.5 208.5 2.29086 208.5 4.5V11.5",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.5H4.5C2.29086 0.5 0.5 2.29086 0.5 4.5V11.5",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.5 135.5H204.5C206.709 135.5 208.5 133.709 208.5 131.5V124.5",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 135.5H4.5C2.29086 135.5 0.5 133.709 0.5 131.5V124.5",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87.5,
    y: 32.5,
    width: 70,
    height: 11,
    rx: 5.5,
    fill: "#BDDDC2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87.5,
    y: 49.5,
    width: 21,
    height: 5,
    rx: 2.5,
    fill: "#BDDDC2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 5,
    rx: 2.5,
    transform: "matrix(-1 0 0 1 157.5 49.5)",
    fill: "#BDDDC2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 166.5,
    y: 67.5,
    width: 79,
    height: 4,
    rx: 2,
    transform: "rotate(180 166.5 67.5)",
    fill: "#BDDDC2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 93.5,
    width: 37,
    height: 4,
    rx: 2,
    transform: "rotate(180 72.5 93.5)",
    fill: "#BDDDC2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 103.5,
    width: 31,
    height: 4,
    rx: 2,
    transform: "rotate(180 66.5 103.5)",
    fill: "#BDDDC2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 111.5,
    width: 42,
    height: 3,
    rx: 1.5,
    transform: "rotate(180 77.5 111.5)",
    fill: "#BDDDC2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    y: 111.5,
    width: 42,
    height: 3,
    rx: 1.5,
    transform: "rotate(180 125.5 111.5)",
    fill: "#BDDDC2"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: 111.5,
    width: 42,
    height: 3,
    rx: 1.5,
    transform: "rotate(180 173.5 111.5)",
    fill: "#BDDDC2"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 102.5,
    y: 103.5,
    width: 31,
    height: 4,
    rx: 2,
    transform: "rotate(180 102.5 103.5)",
    fill: "#BDDDC2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 137.5,
    y: 103.5,
    width: 31,
    height: 4,
    rx: 2,
    transform: "rotate(180 137.5 103.5)",
    fill: "#BDDDC2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 93.5,
    width: 37,
    height: 4,
    rx: 2,
    transform: "rotate(180 115.5 93.5)",
    fill: "#BDDDC2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 158.5,
    y: 93.5,
    width: 37,
    height: 4,
    rx: 2,
    transform: "rotate(180 158.5 93.5)",
    fill: "#BDDDC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup715);
export default __webpack_public_path__ + "static/media/Group 715.68392d77d97e11ce83059e51f44574f7.svg";
export { ForwardRef as ReactComponent };